export const steps = {
    step_1: {
        number: 1,
        text: 'Inicia sesión',
    },
    step_2: {
        number: 2,
        text: 'Completá tus datos',
    },
    step_3: {
        number: 3,
        text: 'Pagá',
    },
};
